module.exports = __webpack_public_path__ + "img/2024-11_research.7b306017.jpg";